//11/7 このmoduleに含まれていたsiteUrl,pathPrefixをコメントアウトした
// 以降graphqlから読み取ること
module.exports = {
  siteTitle: "東京大学 RoboTech", // <title>
  shortSiteTitle: "東京大学 RoboTech", // <title> ending for posts and pages
  siteDescription: "The University of Tokyo",
  //siteUrl: data.site.siteMetadata.siteUrl,
  //pathPrefix: data.site.siteMetadata.pathPrefix,
  siteImage: "https://tuk.t.u-tokyo.ac.jp/robotech/robotech_wheel.png",
  siteLanguage: "ja",

  // トップページに表示する投稿の数
  numofpost: 6,

  /* author */
  authorName: "RoboTech",
  authorTwitterAccount: "UTRoboTech",

  /* info */
  headerTitle: "RoboTech",
  headerSubTitle: "The University of Tokyo",

  /* manifest.json */
  manifestName: "RoboTech - The University of Tokyo",
  manifestShortName: "RoboTech", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [{ name: "twitter", url: "https://twitter.com/UTRoboTech" }]
};
